const TYPE_ID_DAILY = 1;
const TYPE_ID_WEEKLY = 2;
const TYPE_ID_MONTHLY = 3;
const TYPE_ID_INSTANT = 4;

const FREQUENCY_TYPES = [
  {
    id: TYPE_ID_DAILY,
    label: "Daily",
    enabled: true,
  },
  {
    id: TYPE_ID_WEEKLY,
    label: "Weekly",
    enabled: true,
  },
  {
    id: TYPE_ID_MONTHLY,
    label: "Monthly",
    enabled: false,
  },
  {
    id: TYPE_ID_INSTANT,
    label: "Instant",
    enabled: false,
  }
];

const DEFAULT_SCHEDULE_TYPE = 1;
const DEFAULT_WEEKLY_DAY = 1;

export default {
  TYPE_ID_DAILY,
  TYPE_ID_WEEKLY,
  TYPE_ID_MONTHLY,
  TYPE_ID_INSTANT,
  FREQUENCY_TYPES,
  DEFAULT_SCHEDULE_TYPE,
  DEFAULT_WEEKLY_DAY
};
